import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable, Modal } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from '../../styles/colors';
import { useLocation } from 'react-router-dom';
import {
  DefaultModal,
  CenteredView,
  ModalView,
  ModalContainer,
  ModalHeader,
  HeaderText,
  ModalContent,
  CancelX,
  BoldText,
} from './elements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';

const FilterModal = props => {

  const {
    showModal,
    setShowModal,
    refetch,
    modalType,
    sellerId,
    sellerName,
    clearFilters,
    children
  } = props;
  return (
    <ModalContainer
      onPress={() => setShowModal(false)}
    >
      <DefaultModal
        onRequestClose={() => setShowModal(false)}
        visible={showModal}
        transparent={true}
      >
        <CenteredView>
          <ModalView
            onPress={() => false}
          >
            <ModalHeader>
              <HeaderText>Filter Results</HeaderText>
              <Pressable>
                <CancelX>
                  <FontAwesomeIcon
                    icon={faSquareXmark}
                    size='lg'
                    style={{color: '#fff'}}
                    onClick={() => setShowModal(false)}
                  />
                </CancelX>
              </Pressable>
            </ModalHeader>
            <ModalContent>
              {children}
            </ModalContent>
          </ModalView>
        </CenteredView>
      </DefaultModal>
    </ModalContainer>
  )
}

export default FilterModal;
